import React, { useState } from 'react';

interface RatingProps {
    value: number;
    onChange: (value: number) => void;
    disable?: boolean
}

const RatingComment: React.FC<RatingProps> = ({ value, onChange, disable }) => {
    const [hoverValue, setHoverValue] = useState(5);

    return (
        <div>
            <div className="flex items-center rounded-md">
                <p className='ml-3'>امتیازه : {value}</p>
                {[1, 2, 3, 4, 5].map((star) => (
                    <button
                        key={star}
                        type="button"
                        className={`text-2xl focus:outline-none ${(hoverValue || value) >= star ? 'text-yellow-400' : 'text-gray-300'
                            }`}
                        onClick={() => onChange(star)}
                        onMouseEnter={() => setHoverValue(star)}
                        onMouseLeave={() => setHoverValue(0)}
                        disabled={disable}
                    >
                        ★
                    </button>
                ))}
            </div>
        </div>
    );
}

export default RatingComment